import { AppContext } from "./app-context";
import { ServiceContext } from "./service/service-context";

export type Context = AppContext | ServiceContext;
